export default {
  SET_TASKS(state, tasks) {
    state.tasks = tasks;
  },
  SET_TASK(state, task) {
    state.task = task;
  },
};
